import styled from 'styled-components';
import { Container } from 'components/domain/container';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  MIN_MAP_HEIGHT,
  PRODUCT_GALLERY_ASPECT_RATIO_DESKTOP,
  PRODUCT_GALLERY_ASPECT_RATIO_MOBILE,
} from './fdr-hotel-map.constants';
import { MapPin } from '@hotelplan/components.common.map-pin';
import { pinContent } from 'components/domain/fdr-map';

export const FdrHotelMapContainer = styled(Container)(
  sx2CssThemeFn({
    my: ['30px', '40px'],
    '.gallery-with-map-title': {
      mb: '45px',
    },
  })
);

export const FdrHotelMapSection = styled.div<{
  desktop: boolean;
  isFixedHeight: boolean;
}>(({ theme, desktop, isFixedHeight }) => ({
  position: 'relative',
  width: '100%',
  height: isFixedHeight && MIN_MAP_HEIGHT,
  ':after': {
    content: "''",
    display: 'block',
    width: '100%',
    paddingBottom: desktop
      ? PRODUCT_GALLERY_ASPECT_RATIO_DESKTOP
      : PRODUCT_GALLERY_ASPECT_RATIO_MOBILE,
  },
  ...theme.map.controls,
}));

export const FdrMapPinWrapper = styled(MapPin)(sx2CssThemeFn(pinContent));
